import styled from 'styled-components';

export const OrderHeader = styled.h1`
  margin: 0;
  /* font-size: calc((36 / 14) * 1rem * 4/3); */
  line-height: 1.2;
  font-weight: 300;
  opacity: 0.7;
`;

export const OrderTotal = styled.span`
  /* margin: 0 0 0.25em; */
  font-size: calc((36 / 14) * 1rem * 4/3 * 62/48);
  line-height: 1;
  font-weight: 300;
  opacity: unset;
`;

export const OrderPackageHeader = styled.h2`
  margin: 0 0 0.5em 0;
  font-family: 'akzidenz-grotesk', helvetica, 'helvetica neue', arial, sans-serif;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.05rem;
`;

export const OrderPackageList = styled.ol`
  margin: 0;
  list-style: none;
  padding-left: 0;
  margin-bottom: 1em;
  width: 100%;
`;

export const OrderPackageItem = styled.li`
  margin: 0.5em 0 0.75em;
  padding: 0;
  opacity: unset;
`;

export const InvoiceList = styled(OrderPackageList)`
  list-style: none;
  margin-bottom: 0.5em;
  padding-left: 0;
`

export const OrderPackageDenied = styled.p`
  display: flex;
  align-items: center;
  gap: 1em;
  /* justify-content: space-between; */
  margin: 0.75em 0;
  opacity: 1;
`;
